export default __webpack_public_path__ + "static/media/Path 351.a9dd83ac.svg";